import React from 'react';
import PropTypes from 'prop-types';
import ListItemView from './ListItemView';
import documentService from '../../../services/document/DocumentService';
import {captureError} from '../../../utils/log';

function ListItemContainer(props) {
  const [dossierState, setDossierState] = React.useState(null);

  React.useEffect(() => {
    if (!props.showDossierState) {
      return false;
    }

    const aborter = new AbortController();

    setDossierState(null);

    documentService.getInterventionDossierState(props.intervention.interventionId, aborter.signal)
      .then(response => {
        setDossierState(response.dossierState);
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          captureError('Error while fetching intervention dossier state', error);
        }
      });

    return () => {
      aborter.abort();
    };
  }, []);

  return (
    <ListItemView
      intervention={props.intervention}
      dossierState={dossierState}
      showDossierState={props.showDossierState}
    />
  );
}

ListItemContainer.propTypes = {
  intervention: PropTypes.object.isRequired,
  showDossierState: PropTypes.bool
};

export default ListItemContainer;
